import { useWindowSize } from 'usehooks-ts';

// Mobile ends at Tailwind's `md` breakpoint, so JS checks and `md:` utilities flip at the same width.
// The MUI theme overrides `md` to 930px, so `theme.breakpoints.down('md')` is not the same thing.
export const MOBILE_BREAKPOINT = 768;
export const WIDE_DESKTOP_BREAKPOINT = 1400;

const RESIZE_DEBOUNCE_MS = 100;

export const useScreenSize = () => {
  const { width } = useWindowSize({ debounceDelay: RESIZE_DEBOUNCE_MS });

  return {
    isMobile: width < MOBILE_BREAKPOINT,
    isNarrowDesktop: width >= MOBILE_BREAKPOINT && width < WIDE_DESKTOP_BREAKPOINT,
    isWideDesktop: width >= WIDE_DESKTOP_BREAKPOINT,
  };
};
